import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TreeAsset } from "./components/TreeAsset";

export const AssetPage = () => {
	return (
		<>
			<DndProvider backend={HTML5Backend}>
				<TreeAsset />
			</DndProvider>
		</>
	);
};
